import cart from '@ppcp/cart';
import {getSetting} from '@ppcp/utils';
import {CartController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import ApplePayGateway from '../gateways/ApplePayGateway';

const settings = getSetting('ppcp_applepay_data');
const {disabled = false} = settings;

if (!disabled) {
    const gateway = new ApplePayGateway({
        id: 'ppcp_applepay',
        cart,
        settings
    });

    const context = new Context('cart');

    const controller = new CartController({
        id: 'ppcp_applepay',
        cart,
        context,
        gateway,
        settings
    });

    controller.initialize();
}